import React, { useState, useLayoutEffect } from 'react'
import ReactDOM from 'react-dom';

const Hotspots = (props) => {
   const { menuList, hotspotData } = props;

   /*Menu List */
   // console.log('Hotspots called----', menuList);
   let subMenuListArr = [];

   menuList.forEach(menu => {
      subMenuListArr.push(menu.items)
   });

   let subMenuList = subMenuListArr.flat();
   // console.log('subMenuList----', subMenuList);
   /*Menu List */


   /*HotspotData */
   // console.log('hotspotData----', hotspotData);
   let hotspotDataKeys = Object.keys(hotspotData);
   let hotspotDataArray = [];
   // console.log('hotspotDataKeys ', hotspotDataKeys);
   // console.log('hotspotDataArray ', hotspotDataArray);
   hotspotDataKeys.forEach(keyName => {
      // console.log(hotspotData[element]);
      hotspotData[keyName].forEach(subElement => {
         // console.log('subElement ', subElement)
         subElement['hsParentType'] = keyName;
         hotspotDataArray.push(subElement);
      });
   });
   // console.log('hotspotDataArray----', hotspotDataArray);
   /*HotspotData */
   return (
      hotspotDataArray.map((hotspot) => {
         // let popupId = hotspot.popupId;

         let list = subMenuList.find(subMenu => subMenu.popupId === hotspot.popupId);
         // console.log('list ', list.id);
         return (
            ReactDOM.createPortal(<div onKeyDown={(event) => {
               if (event.key !== 'Enter') {
                  return
               } props.handleMenuClick(list, event)
            }} onClick={(event) => {
               props.handleMenuClick(list, event)
            }} id={hotspot.hsname} className={"calloutbox popupbox tempHotspot hsParentType_" + hotspot.hsParentType + " hotspotMenuId_" + list.id} data-info={JSON.stringify(hotspot)}>
               <div className="" id="dimensionsWrapper">
                  {hotspot.icon && <img src={hotspot.icon} alt={list.popupHeading} /> }
                  {hotspot.text && <span className='dimensionText'>{hotspot.text}</span>}
                  {hotspot.icon2 && <img src={hotspot.icon2} alt={list.popupHeading} />}
               </div>

            </div>, document.getElementById('calloutbox_wrapper'))
         )
      })
   )
}

export default Hotspots